import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/authentication/Login')));
const AuthRegister = Loadable(lazy(() => import('views/authentication/Register')));
const AuthForgotPassword = Loadable(lazy(() => import('views/authentication/ForgotPassword')));
const AuthResetPassword = Loadable(lazy(() => import('views/authentication/ResetPassword')));
const AuthNewPassword = Loadable(lazy(() => import('views/authentication/NewPassword')));
const AuthCodeVerification = Loadable(lazy(() => import('views/authentication/CodeVerification')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/login',
            element: <AuthLogin />
        },
        {
            path: '/register',
            element: <AuthRegister />
        },
        {
            path: '/verify',
            element: <AuthCodeVerification />
        },
        {
            path: '/forgot',
            element: <AuthForgotPassword />
        },
        {
            path: '/reset',
            element: <AuthResetPassword />
        },
        {
            path: '/new',
            element: <AuthNewPassword />
        }
    ]
};

export default LoginRoutes;
